(function($) {
  'use strict';

  const init = {
    headerHeight: Math.floor($('#header .header__columns').outerHeight()),

    dom: function() {
      this.$html = $('html');

      this.$utility = $('#utility');
      this.$header = $('#header');
      this.$mainNav = $('#main-nav');

      this.picker = null;
      this.pickerObj = null;
      this.petPolicy = {
        $button: $('#pet-policy'),
        $flyout: $('#pet-policy-flyout')
      };

      this.modal = {
        $toggle: $('[data-modal-open]'),
        $modal: $('[data-modal-id]')
      };

      this.$truncatedExpand = $('[data-js-hook="expand-content"]');

      this.$hours = {
        toggle: $('[data-js-hook="hours"]'),
        modal: $('#propertyHours')
      };

      this.$toggle = $('[data-toggle]');
      this.$stickyHeader = $('#sticky-header');
      this.$email = $('[data-mail-name]');
      this.$lazyImage = $('[data-src]');
      this.$lazyEmbed = $('.lazyembed');
      this.$ebrochure = $('#ebrochure');
      this.$petPolicyTrigger = $('[href*="#pet-policy"]');
      this.$pageBannerImage = $('#page-banner-image');
    },

    setHeaderHeight: function() {
      let heroHeight = 0;
      let width = window.innerWidth;

      function setHeights(heroHeight) {
        init.headerHeight = Math.floor(init.$header.find('.header__columns').outerHeight());
        heroHeight = heroHeight + (init.$utility.length && init.$utility.is(':visible') ? Math.floor(init.$utility.outerHeight()) : 0);
        heroHeight = heroHeight + (init.$header.length && init.$header.is(':visible') ? init.headerHeight : 0);
        heroHeight = heroHeight + (init.$mainNav.length && init.$mainNav.is(':visible') ? Math.floor(init.$mainNav.outerHeight()) : 0);
        heroHeight = window.innerHeight - heroHeight;
        $('html').css('--jd-hero-height', heroHeight + 'px');
      }
      $(window).on('load resize', function(event) {
        if (event.type == 'resize' && width == window.innerWidth) { return; }
        let heroHeight = 0;
        setHeights(heroHeight);

        setTimeout(function() {
          setHeights(heroHeight);
        }, 1000);
      });
    },

    initPageBannerImage: function() {

      if (this.$pageBannerImage.length) {
        var $parent = this.$pageBannerImage.parent();

        if (this.$pageBannerImage.data('movement') === 'parallax') {
          this.$pageBannerImage.height($parent.outerHeight()).fadeIn(200);

          $(window).on('resize', function() {
            init.$pageBannerImage.height($parent.outerHeight());
          });

          $(window).on('load scroll', function() {
            var offset = $(window).scrollTop() - $parent.offset().top;
            var leftOffset = 0;

            if (offset <= 0) {
              init.$pageBannerImage.css({position: 'absolute', left: 0, width: '100%'});
            }
            else {
              init.$pageBannerImage.css({
                position: 'fixed',
                left: leftOffset,
                width: leftOffset > 0 ? ('calc(100% - ' + leftOffset + 'px)') : '100%'
              });
            }
          });
        }
      }
    },

    initTracking: function() {

      $.getScript('/jonahlytics/dist/jonahlytics.min.js', function() {
        Jonahlytics.init({
          leaseUrl: typeof leaseUrl != 'undefined' ? leaseUrl : null,
          mapUrl: typeof mapUrl != 'undefined' ? mapUrl : null,
          anchorIgnore: '.check-availability__cell-link'
        });

        init.$ebrochure.on('submit', function(e) {
          var analyticData = [];
          var $checked = $(this).find('input:checked');

          if ($checked.length) {
            $checked.each(function() {
              analyticData.push($(this).data('analytic-data'));
            });
          }

          Jonahlytics.event.ebrochure(JSON.stringify(analyticData));
        });

        // -- Fire on-load floorplan view event (executes when accessing a single page directly)
        if (typeof floorplanViewId != 'undefined') {
          Jonahlytics.event.floorplanView(floorplanViewId);
        }
      });
    },

    lazyLoad: function() {
      this.$lazyImage.lazyload();

      this.$lazyEmbed.lazyload({
        type: 'embed',
      });
    },

    execPetPolicy: function() {
      var policyCloserTimeout;

      this.petPolicy.$flyout.mouseenter(function() {
        clearTimeout(policyCloserTimeout);
      }).mouseleave(function() {
        init.petPolicy.$button.removeClass('header__toolbar-content--active-pet');
        init.petPolicy.$flyout.fadeOut(100);
      });

      this.petPolicy.$button.click(function(e) {
        e.preventDefault();
        $(this).addClass('header__toolbar-content--active-pet');
        init.petPolicy.$flyout.fadeToggle(100).focus();
      }).mouseleave(function(e) {
        var $this = $(this);

        policyCloserTimeout = setTimeout(function() {
          $this.removeClass('header__toolbar-content--active-pet');
          init.petPolicy.$flyout.fadeOut(100).blur();
        }, 30);
      });
    },

    fancybox: function() {
      jutil.bindFancybox();
    },

    email: {
      convert: function($element) {
        var email = $element.data('mail-name') + '@' + $element.data('mail-host');
        $element.attr('href', 'mailto:' + email);
        if ($element.text() == '') {
          $element.text(email);
        }
        $element.removeAttr('data-mail-name');
        $element.removeAttr('data-mail-host');
      },

      mailToInject: function(el) {
        if (el) {
          init.email.convert(el);
        }
        else {
          init.$email.each(function() {
            init.email.convert($(this));
          });
        }
      }
    },

    wow: function() {
      if (typeof useSiteAnimations !== 'undefined' && typeof WOW == 'function') {
        var wow = new WOW({
          boxClass: 'wow',
          animateClass: 'animated',
          offset: 100,
          mobile: false,
          live: false
        });

        $('html').data('wow', wow);

        wow.init();
      }
    },

    rotatorTopOffset: {
      doOffset: function() {
        if ($('#homepage_rotator').hasClass('rotator-parallax--fixed')) {
          const doOffset = true;
          const topOffset = $('#homepage_rotator').offset().top - $(window).scrollTop();
          const leftOffset = 0
          const $images = $('#homepage_rotator').find('.homepage__rotator-image-container');

          if (doOffset) {
            if (topOffset >= 0) {
              $images.css({position: 'absolute'});

              if (leftOffset) {
                $images.css({left: (leftOffset * -1), width: 'calc(100% + ' + leftOffset + 'px)'});
              }
            }
            else {
              $images.css({position: 'fixed'});

              if (leftOffset) {
                $images.css({left: 0, width: '100%'});
              }
            }
          }
          else {
            $images.css({left: 0, width: '100%'});
          }
        }
      },

      init: function() {

        $('#homepage_rotator').on('set-image-height', function() {
          $('#homepage_rotator').find('.homepage__rotator-image-container').height($('#homepage_rotator').outerHeight());
        });

        $(window).on('load scroll resize', function() {
          init.rotatorTopOffset.doOffset();

          $('#homepage_rotator').trigger('set-image-height');
        });

        setTimeout(function() {
          $('#homepage_rotator').find('.homepage__rotator-image').css('opacity', 1);
        }, 200);
      }

    },

    findYourApartmentToggle: function() {
      if ($('[href*="find-your-apartment"]').length) {
        $('[href*="find-your-apartment"]').magnificPopup({
          type: 'iframe',
          mainClass: 'find-your-apartment-embed',
          closeMarkup: '<a title="%title%" type="button" class="mfp-close">&times;</a>',
          callbacks: {
            open: function() {
              $('body').css({
                position: 'fixed',
                width: '100%'
              });
            },

            close: function() {
              $('body').css({
                position: '',
                width: ''
              });
            }
          }
        });


        $('body').on('fya.details.open', function() {
          $('.mfp-close').addClass('hidden');
        }).on('fya.details.hide', function() {
          $('.mfp-close').removeClass('hidden');
        });

      }
    },

    initModal: function() {
      jutil.bindModal();
    },

    truncatedContent: function() {
      if (typeof this.$truncatedExpand != 'undefined') {
        this.$truncatedExpand.click(function(event) {
          event.preventDefault();
          let $parent = $(this).closest('[data-truncated="cut"]');
          $parent.hide();
          $parent.next('[data-truncated="full"]').show();
        });
      }
    },

    /*
    * Function checks all phone links for possible DNI
    * insertion and changes aria-labels accordingly
    * for accessibility compliance. Checks twice a
    * second for 10 seconds, then gives up.
    */
    checkPhoneLinksForAccessibility: function() {
      var $phoneLinks = $('[href^=tel]');
      var checkIteration = 0;

      var runPhoneLinkCheck = function(callback) {
        $phoneLinks.each(function() {
          var phoneText = $(this).text().trim();

          if (!$(this).data('original-phone-text')) {
            $(this).data('original-phone-text', phoneText);
          }

          if (phoneText != $(this).data('original-phone-text')) {
            callback();

            $(this).attr('aria-label', 'Call us at ' + phoneText);
          }
        });
      };

      // -- Run immediately
      runPhoneLinkCheck();

      // -- Run twice a second for ten seconds.
      var phoneCheckInterval = setInterval(function() {
        if (checkIteration == 20) {
          clearInterval(phoneCheckInterval);
        }

        runPhoneLinkCheck(function() {
          clearInterval(phoneCheckInterval);
        });

        ++checkIteration;
      }, 500);
    },

    /*
    * Function checks all images and iframes about 3 times
    * a second for 12 seconds (total 40 times) to find
    * images or iFrames injected by third parties
    * without the proper "title" (and "alt" for images)
    * tags, and applies a role="presentation" to
    * pass SiteImprove audits.
    */
    checkImgandIframes: function() {
      var imgCheckIteration = 0;

      var runImgiFrameCheck = function() {
        $('img,iframe').each(function() {
          if (!$(this).attr('alt') && !$(this).attr('title') && $(this).attr('role') != 'presentation') {
            $(this).attr('role', 'presentation').attr('aria-hidden', true);
          }
        });
      };

      runImgiFrameCheck();

      var imgCheckInerval = setInterval(function() {
        if (imgCheckIteration == 40) {
          clearTimeout(imgCheckInerval);
        }

        ++imgCheckIteration;
        runImgiFrameCheck();
      }, 300);
    },

    addOnZIndexCorrector: function() {
      /**
       * This bit is a bandaid for Tour Scheduler. Third
       * party scripts that take forever to inject will
       * not be present when this is run, so will still
       * appear above Tour Scheduler. Only correct way
       * to do this is to build into Tour Scheduler,
       * or supply an event  system through TS we
       * can hook into like we do below for
       * SkyLease.
       */
      var i, addOnSelectors = [
        '.ts__modal'
      ];

      for (i = 0; i < addOnSelectors.length; i++) {
        var selector = addOnSelectors[i];

        if ($(selector).length) {
          $(selector).css('z-index', maxZ() + 1);
        }
      }

      /**
       * This is temporary. SkyLease will and should handle
       * this internally eventually. I'm checking for a
       * setting on SkyLease's fpmData object called
       * "ignoreExternalZIndexListeners" so whenever
       * SkyLease is updated to handle this, I can
       * simply set that value and everything here
       * will stop executing, and therefore won't
       * conflict. (So we don't have to make a
       * SkyLease and Premium update at the
       * same time.)
       */
      if (typeof SkyLeaseEvent != 'undefined' && typeof fpmData != 'undefined' && !fpmData.ignoreExternalZIndexListeners) {
        // -- Make sure unit box appears above all third-party widgets
        SkyLeaseEvent.on('detail-load', function(e) {
          var nextZ = maxZ() + 1;

          e.detailInstance.$detailFrame.css('z-index', nextZ);

          // -- Make sure Tour Scheduler appears above unit box.
          if ($('.ts__modal').length) {
            $('.ts__modal').css('z-index', nextZ + 1);
          }
        });

        // -- Make sure calendar selector appears above unit box
        SkyLeaseEvent.on('opened-move-in-date-selector', function(e) {
          e.instance.picker.$root.css('z-index', maxZ() + 1);
        });
      }
    },

    vtmMaxZOverride: {
      bind: function() {
        // $('[data-js-hook="walkthrough-embed"]').each(function(){
        //   var $this = $(this);
        //
        //   if (!$this.data('vtm-z-bound')) {
        //     $this.data('vtm-z-bound', 1).click(function(){
        //       setTimeout(function(){
        //         var z = maxZ() + 1;
        //         var $lightbox = $('.mfp-wrap, .mfp-bg');
        //
        //         $lightbox.css('z-index', z);
        //       }, 500);
        //     });
        //   }
        // });

        if ($('.walkthrough__action-button').length) {
          $('.walkthrough__action-button').each(function() {
            $(this).html('<span class="vertaligner-primary">' + $(this).text() + '</span>');
          });

        }
      },

      init: function() {
        this.bind();

        $('.walkthroughs__tab').click(function() {
          var $this = $(this);

          var i = setInterval(function() {
            if ($this.hasClass('walkthroughs__tab--active')) {
              clearInterval(i);
              init.bind();
            }
          }, 100);
        });
      }
    },

    toggle: function() {
      this.$toggle.click(function(event) {
        event.preventDefault();
        let $this = $(this);
        let target = $this.data('toggle');
        let $target = $(target);
        let eventClass = target.replace('#', '').replace('.', '').replace('_', '-');

        if ($target.length) {
          init.$html.toggleClass(eventClass + '-active');
          $target.fadeToggle();
        }
      });
    },

    hoursModal: function() {
      this.$hours.toggle.click(function() {
        init.$hours.modal.fadeToggle(function() {
          htmlOverflow(init.$hours.modal);
        });
      });
    },

    variableReplacement: function() {
      const $links = $('a[href*="{"]');
      $links.each(function() {
        let href = $(this).attr('href');

        href = href.replace('/{PROPERTY}', jcms.property.property_path);
        href = href.replace('{PROPERTY}', jcms.property.property_path);

        if (typeof jcms.reviews_property_identifier != 'undefined') {
          href = href.replace('{REVIEWS_PROPERTY_IDENTIFIER}', jcms.reviews_property_identifier);
        }

        $(this).attr('href', href);
      });
    },

    getOffset: function($element) {
      const offset = Math.ceil($element.offset().top);
      if (typeof jcms.stickyHeader != 'undefined' && jcms.stickyHeader == 'desktop_only' && $(window).width() <= 808) {
        return offset;
      }
      return init.$header.length ? Math.ceil(offset - init.headerHeight) : offset;
    },

    hashScroll: function() {
      $(window).on('load', function() {
        if (typeof window.location.hash != 'undefined') {
          let hash = window.location.hash.replace(/^\/|\/$/g, '');
          let $hash = $(hash);
          if ($hash.length && $hash.is(':visible')) {
            let offset = init.getOffset($hash);
            setTimeout(function() {
              $('html,body').animate({
                scrollTop: offset
              });
              setTimeout(function() {
                offset = init.getOffset($hash);
                $('html,body').animate({
                  scrollTop: offset
                }, 500);
              }, 'fast');
            }, 'slow');
          }
        }
      });

      $('a[href^="#"], a[href^="/#"]').not('[href="#"]').click(function(e) {
        e.preventDefault();

        let dest = $(this).attr('href');
        let $dest = $(dest.replace('/#', '#').replace(/^\/|\/$/g, ''));

        if ($dest.length) {
          let offset = init.getOffset($dest);
          $('html,body').animate({
            scrollTop: offset
          }, 'slow', function() {
            // Run again just in case the header height changed
            offset = init.getOffset($dest);
            $('html,body').animate({
              scrollTop: offset
            }, 'fast');
          });
        }
        else {
          window.location.href = $(this).attr('href');
        }
      });
    },

    ready: function() {
      this.dom();
      this.setHeaderHeight();
      this.lazyLoad();
      this.execPetPolicy();
      this.fancybox();
      this.email.mailToInject();
      this.wow();
      this.findYourApartmentToggle();
      this.initModal();
      this.initTracking();
      this.truncatedContent();
      this.checkPhoneLinksForAccessibility();
      this.checkImgandIframes();
      this.initPageBannerImage();
      this.vtmMaxZOverride.init();
      this.rotatorTopOffset.init();
      this.toggle();
      this.hoursModal();
      this.variableReplacement();
      this.hashScroll();

      if (this.$petPolicyTrigger.length) {
        this.$petPolicyTrigger.click(function(e) {
          e.preventDefault();
          $('[data-modal-open="pet-policy"]').trigger('click');
        });
      }

      /**
       * Commenting out for now. Causing issues with
       * tour override forms appearing behind
       * SkyLease unit lightboxes.
       */
        // this.addOnZIndexCorrector();

      var touchPoints = navigator.maxTouchPoints || 0;

      if (touchPoints > 1) {
        $('html').addClass('touch-device');
      }

      $(window).on('load', function() {
        $('html').addClass('loaded').removeClass('no-js');
      });
    }
  };

  $(function() {
    init.ready();
  });

})(jQuery);
